import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export { default as Img } from './Img.vue';

export const imgVariants = cva('inline-block', {
  variants: {
    objectFit: {
      contain: 'object-contain',
      cover: 'object-cover',
      fill: 'object-fill',
      none: 'object-none',
      scaleDown: 'object-scale-down',
    },
    loading: {
      lazy: 'loading-lazy',
      eager: 'loading-eager',
    },
  },
  defaultVariants: {
    objectFit: 'cover',
    loading: 'lazy',
  },
});

export type ImgVariants = VariantProps<typeof imgVariants>;

// OSS 图片处理参数类型
export interface OssImageParams {
  width?: number;
  height?: number;
  quality?: number;
  format?: 'webp' | 'jpg' | 'png' | 'gif';
  blur?: number;
  sharpen?: number;
  rotate?: number;
  flip?: 'horizontal' | 'vertical';
  crop?: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
}

// 支持的图片格式
export const SUPPORTED_IMAGE_FORMATS = ['png', 'jpg', 'jpeg', 'webp', 'gif'] as const;
export type SupportedImageFormat = (typeof SUPPORTED_IMAGE_FORMATS)[number];

// 视频文件扩展名
export const VIDEO_EXTENSIONS = [
  '.mp4',
  '.mov',
  '.avi',
  '.mpeg',
  '.wmv',
  '.rmvb',
  '.webm',
] as const;
